<template>
    <Page>
        <div class="client-filter">
            <van-collapse v-model="activeNames_one" class="van-cell-flexs">
                <van-collapse-item title="客户基本信息" name="1">
                    <!-- 客户姓名 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">客户姓名：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="queryParams.custName"
                            placeholder="请输入客户姓名"
                        >
                    </div>
                    <!-- 手机号码 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">手机号码：</div>
                        <input
                            type="number"
                            class="inputs"
                            maxlength="11"
                            v-model="queryParams.mobile"
                            placeholder="请输入手机号码"
                            ref="br"
                        >
                    </div>
                    <!-- 生日日期 -->
<!--                    <div class="flex itemCenter cell-list-item cell-list-item-active">-->
<!--                        <div class="birthday-flex-style-one title1">生日：</div>-->
<!--                        <div class="birthday-flex-style-one" @click="selectTime(1)">-->
<!--                            {{birthday[0]|| '全部'}}-->
<!--                            <img-->
<!--                                :src="require('@/assets/img/uparrow.png')"-->
<!--                                class="uparrow"-->
<!--                                alt=""-->
<!--                                srcset=""-->
<!--                            >-->
<!--                        </div>-->
<!--                        <div class="birthday-flex-style-one" @click="selectTime(1.1)">-->
<!--                            {{birthday[1]|| '全部'}}-->
<!--                            <img-->
<!--                                :src="require('@/assets/img/uparrow.png')"-->
<!--                                class="uparrow"-->
<!--                                alt=""-->
<!--                                srcset=""-->
<!--                            >-->
<!--                        </div>-->
<!--                    </div>-->
                    <!-- 客户类型 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">客户类型：</div>
                        <div class="pull-down-selects" data-id="0" @click="downSelections(0)">
                            {{pullList[0]['name'] || '全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- VIP等级： 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">VIP等级：</div>
                        <div class="pull-down-selects" data-id="1" @click="downSelections(1)">
                            {{pullList[1]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 徕卡会员： 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">徕卡会员：</div>
                        <div class="pull-down-selects" data-id="2" @click="downSelections(2)">
                            {{pullList[2]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 摄影主题： 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">摄影主题：</div>
                        <div class="pull-down-selects" data-id="3" @click="downSelections(3)">
                            {{pullList[3]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 兴趣爱好： 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">兴趣爱好：</div>
                        <div class="pull-down-selects" data-id="4" @click="downSelections(4)">
                            {{pullList[4]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 结婚纪念日： -->
<!--                    <div class="flex itemCenter cell-list-item cell-list-item-active">-->
<!--                        <div class="birthday-flex-style-one title1">结婚纪念日：</div>-->
<!--                        <div class="birthday-flex-style-one" @click="selectTime(1.2)">-->
<!--                            {{souvenir[0]||'全部'}}-->
<!--                            <img-->
<!--                                :src="require('@/assets/img/uparrow.png')"-->
<!--                                class="uparrow"-->
<!--                                alt=""-->
<!--                                srcset=""-->
<!--                            >-->
<!--                        </div>-->
<!--                        <div class="birthday-flex-style-one" @click="selectTime(1.3)">-->
<!--                            {{souvenir[1]||'全部'}}-->
<!--                            <img-->
<!--                                :src="require('@/assets/img/uparrow.png')"-->
<!--                                class="uparrow"-->
<!--                                alt=""-->
<!--                                srcset=""-->
<!--                            >-->
<!--                        </div>-->
<!--                    </div>-->
                    <!-- 门店： 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">门店：</div>
                        <div class="pull-down-selects" data-id="5" @click="downSelections(5)">
                            {{pullList[5]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 销售顾问： 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">销售顾问：</div>
                        <div class="pull-down-selects" data-id="6" @click="pullList[5]['val']?downSelections(6):''">
                            {{pullList[6]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <van-collapse v-model="activeNames_two" class="van-cell-flexs">
                <van-collapse-item title="购买信息" name="">
                    <!-- 购买日期： -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one title1">购买日期：</div>
                        <div class="birthday-flex-style-one" @click="selectTime(1.4)">
                            {{buyDate[0]||"全部"}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                        <div class="birthday-flex-style-one" @click="selectTime(1.5)">
                            {{buyDate[1]||"全部"}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 购买产品大类 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">购买产品大类：</div>
                        <div class="pull-down-selects" data-id="7" @click="downSelections(7)">
                            {{pullList[7]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 购买产品分类 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">购买产品分类：</div>
                        <div class="pull-down-selects" data-id="8" @click="downSelections(8)">
                            {{pullList[8]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 购买意向状态 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">购买意向状态：</div>
                        <div class="pull-down-selects" data-id="9" @click="downSelections(9)">
                            {{pullList[9]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 预计购买日期 下拉单选 -->
<!--                    <div class="flex itemCenter cell-list-item cell-list-item-active">-->
<!--                        <div class="birthday-flex-style-one title1">预计购买日期：</div>-->
<!--                        <div class="birthday-flex-style-one" @click="selectTime(1.6)">-->
<!--                            {{predictBuyDate[0]||"全部"}}-->
<!--                            <img-->
<!--                                :src="require('@/assets/img/uparrow.png')"-->
<!--                                class="uparrow"-->
<!--                                alt=""-->
<!--                                srcset=""-->
<!--                            >-->
<!--                        </div>-->
<!--                        <div class="birthday-flex-style-one" @click="selectTime(1.7)">-->
<!--                            {{predictBuyDate[1]||"全部"}}-->
<!--                            <img-->
<!--                                :src="require('@/assets/img/uparrow.png')"-->
<!--                                class="uparrow"-->
<!--                                alt=""-->
<!--                                srcset=""-->
<!--                            >-->
<!--                        </div>-->
<!--                    </div>-->
                    <!-- 优惠劵 下拉单选 -->
<!--                    <div class="flex itemCenter cell-list-item">-->
<!--                        <div class="input-title title1">优惠劵：</div>-->
<!--                        <div class="pull-down-selects" data-id="10" @click="downSelections(10)">-->
<!--                            {{pullList[10]['name']||'全部'}}-->
<!--                            <img-->
<!--                                :src="require('@/assets/img/uparrow.png')"-->
<!--                                class="uparrow"-->
<!--                                alt=""-->
<!--                                srcset=""-->
<!--                            >-->
<!--                        </div>-->
<!--                    </div>-->
                    <!-- 劵号 输入框 -->
<!--                    <div class="flex itemCenter cell-list-item">-->
<!--                        <div class="input-title title1">劵号：</div>-->
<!--                        &lt;!&ndash; <div class="pull-down-selects"></div> &ndash;&gt;-->
<!--                        <input-->
<!--                            type="text"-->
<!--                            class="inputs"-->
<!--                            v-model="pullList[11]['name']"-->
<!--                            maxlength="50"-->
<!--                            placeholder="请输入劵号"-->
<!--                        >-->
<!--                    </div>-->
                    <!-- 购买门店 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">购买门店：</div>
                        <div class="pull-down-selects" data-id="11" @click="downSelections(12)">
                            {{pullList[12]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>

                  <!-- 购买产品大类 下拉单选 -->
                  <div class="flex itemCenter cell-list-item">
                    <div class="input-title title1">是否注册产品：</div>
                    <div class="pull-down-selects" data-id="15" @click="downSelections(15)">
                      {{pullList[15]['name']||'全部'}}
                      <img
                        :src="require('@/assets/img/uparrow.png')"
                        class="uparrow"
                        alt=""
                        srcset=""
                      >
                    </div>
                  </div>
                </van-collapse-item>
            </van-collapse>
            <van-collapse v-model="activeNames_three" class="van-cell-flexs" v-if="false">
                <van-collapse-item title="参与信息" name="">
                    <!-- 参与活动日期 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one title1">参与活动日期：</div>
                        <div class="birthday-flex-style-one" @click="selectTime(1.8)">
                            {{activeJoinDate[0]||"全部"}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                        <div class="birthday-flex-style-one" @click="selectTime(1.9)">
                            {{activeJoinDate[1]||"全部"}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 劵号 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">参与活动：</div>
                        <div class="pull-down-selects" data-id="12" @click="downSelections(13)">
                            {{pullList[13]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 参与课程日期 下拉单选 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one title1">参与课程日期：</div>
                        <div class="birthday-flex-style-one" @click="selectTime(2)">
                            {{courseJoinDate[0]||"全部"}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                        <div class="birthday-flex-style-one" @click="selectTime(2.1)">
                            {{courseJoinDate[1]||"全部"}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 参与课程 下拉单选 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title title1">参与课程：</div>
                        <div class="pull-down-selects" data-id="13" @click="downSelections(14)">
                            {{pullList[14]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                </van-collapse-item>
            </van-collapse>


            <van-collapse v-model="activeNames_label" class="van-cell-flexs">
                <van-collapse-item title="客户标签" name="">
                    <van-collapse v-model="activeNames">
                        <van-collapse-item  v-for="(item,index) in labelList" :title="item.labelName" :key="index" :name="item.id">
                            <!-- <div slot="title" class="collapse-tit">
                                <div class="text">{{item.labelName}}</div>
                                <div class="tip"> 请选泽标签 </div>
                            </div> -->
                            <div v-if="item.children && item.children.length>0">

                                <template v-for="(childrenItem) in item.children" >
                                    <div v-if="childrenItem.id" :key="childrenItem.id">
                                        <div class="flex itemCenter cell-list-item" >
                                            <div class="input-title title1">{{ childrenItem.labelName }}:</div>
                                            <div class="pull-down-selects" @click="handNav(childrenItem)">
                                                {{showTagCnt(childrenItem)}}
                                                <img :src="require('@/assets/img/uparrow.png')" class="uparrow"  alt=""  srcset="">
                                            </div>
                                        </div>
                                        <div :key="childrenItem.id" v-if="childrenItem.active"  class="taglist">
                                            <span v-for="(info,infoIndex) in childrenItem.children" :key="infoIndex">
                                                <van-tag :plain="info.use!==1" :color="info.use==1?'red':'#000'" @click="handTag(info)" size="large">{{info.labelName}}</van-tag>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <!-- <div class="tabsub">
                                <div v-if="item.children && item.children.length>0" class="tabNav">
                                    <div v-for="(childrenItem,childrenIndex) in item.children" @click.stop="handTreeTab(item,childrenItem.id,childrenIndex)" :title="childrenItem.id" :key="childrenIndex"
                                        :class="{'navItem--active':(item.active==childrenItem.id || !item.active && childrenIndex==0) }" class="navItem">
                                        {{childrenItem.labelName}}
                                    </div>
                                </div>
                                <div v-if="item.children && item.children.length>0" class="tabcontent">
                                    <template v-for="(childrenItem,childrenIndex) in item.children" >
                                        <div  v-if="item.active==childrenItem.id || !item.active && childrenIndex==0" :key="childrenItem.id" :title="childrenItem.labelName" class="conItem">
                                            <span v-for="(info,infoIndex) in childrenItem.children" :key="infoIndex">
                                                <van-tag v-if="info.type==2" :plain="info.use!==1" :color="info.use==1?'red':'#000'" @click="handTag(info)" size="large">{{info.labelName}}</van-tag>
                                            </span>
                                        </div>
                                    </template>
                                </div>
                            </div> -->

                        </van-collapse-item>
                    </van-collapse>

                </van-collapse-item>
            </van-collapse>

            <!-- 底部取消和确定按钮 -->
            <div class="bottom_button">
                <div class="button_cancel" @click="button_cancel">清空</div>
                <div class="button_confirm" @click="button_confirm">搜索</div>
            </div>
            <!-- 时间筛选 -->
            <van-popup v-model="timeShow" position="bottom" :overlay="true" style="width:100%">
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    @confirm="timeConfirm"
                    @cancel="timeCancel"
                    @change="timeChange"
                    :min-date="minDate"
                    :max-date="maxDate"
                />
            </van-popup>
            <!-- 下拉筛选 -->
            <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
                <van-picker
                    show-toolbar
                    title=""
                    :columns="downSelection"
                    @cancel="onCancelCode"
                    @confirm="onConfirmCode"
                     :value-key="'name'"
                    class="van-picker-li"
                />
            </van-popup>
        </div>
    </Page>
</template>



<script>
function flattern(data) {
  return data.reduce((iter, val) => {
    //use =1 选中， type=2 自定义标签，level==3 最后一级
    if(val.use==1 && (val.type==1 || val.type==2) && val.level==3) iter.push(val.id);
    return val.children ? [...iter, ...flattern(val.children)] : iter;
  }, []);
}
export default {
  name: "client-filter",
  data() {
    return {
      activeNames_one: ["1"],
      activeNames_two: ["1"],
      activeNames_three: ["1"],
      activeNames_label: ["1"],
      height: 0,
      regProduct:[
        {name:"否",val:"0"},
        {name:"是",val:"1"},
      ],
      pullList: [
        {name:"",val:""}, //客户的类型 0
        {name:"",val:""}, //VIP等级 1
        {name:"",val:""}, //徕卡会员 2
        {name:"",val:""}, //摄影主题 3
        {name:"",val:""}, //兴趣爱好 4
        {name:"",val:""}, //门店 5
        {name:"",val:""}, //销售顾问 6
        {name:"",val:""}, //购买产品大类 7
        {name:"",val:""}, //购买产品分类 8
        {name:"",val:""}, //购买意向状态 9
        {name:"",val:""}, //优惠卷 10
        {name:"",val:""}, //劵号 11
        {name:"",val:""}, //购买门店 12
        {name:"",val:""}, //参与活动 13
        {name:"",val:""}, //参与课程 14
        {name:"",val:""}, //是否注册产品 15
      ], //下拉选项默认值
      birthday: ["", ""], // 生日选项
      souvenir: ["", ""], // 结婚纪念日
      buyDate: ["", ""], //  购买日期
      predictBuyDate: ["", ""], //预计购买日期
      activeJoinDate: ["", ""], //活动参与日期
      courseJoinDate: ["", ""], //课程参与日期
      currentDate:"", // 时间
      minDate:"", // 最小时间
      maxDate:"",
      timeShow: false, // 时间展示
      showDownSelection: false, // 下拉筛选
      timeVal: 0, // 当前的时间是第几个选项
      downSelectionVal: 0, // 当前的下拉菜单是几个人  对应->pullList 数组
      clientName: "", // 客户姓名
      phone: "", // 手机号码
      securities: "", // 劵号
      downSelection: ["这是第一个", "这是第二个"] ,// 下拉筛选全部数组综合
      type:'',  // 判断来自页面类型
      // 字典表查询code
      codeList:['CustomerType','VIP Level','MenbersType','ShootingType','Hobby','Products1stType','Products2ndType','Intention','CouponType'],
      CustomerType:[],//客户类型
      VIPLevel:[],//VIP等级
      MenbersType:[],//莱卡会员
      ShootingType:[],//摄影主题
      Hobby:[],//兴趣爱好
      Products1stType:[], //产品大类
      Products2ndType:[],  //产品分类
      Intention:[], //购买意向
      CouponType:[], //优惠券类型
      Dealer: [], // 门店     经销商列表
      Sales: [] ,// 销售顾问  销售用户
      campaign:[], //参与活动
      course:[],  //参与课程
      queryParams : {
        courseStartDate : "",//课程时间段  开始时间
        courseEndDate:    '',//课程时间段  结束时间
        courseId:         '',//课程ID
        registerStartDate:'',//参加活动 开始时间
        registerEndDate:  '',//参加活动 结束时间
        campaignId:       '',//活动ID
        intention:        '',//购买意向
        purchaseStartDate:'',//产品购买时间 开始时间
        purchaseEndDate:  '',//产品购买时间 结束时间
        custName:         '',//客户姓名
        mobile:           '',//手机号码
        birthdayStartDate:'',//客户生日 开始时间
        birthdayEndDate:  '',//客户生日 结束时间
        vipLevel:         '',//VIP 等级
        member:           '',//徕卡会员
        custType:         '',//客户类型
        custTypeName:     '',//客户类型名称
        shootingType:     '',//摄影主题
        hobby:            '',//兴趣爱好
        weddingStartDate: '',//结婚纪念日 开始时间
        weddingEndDate:   ''//结婚纪念日 结束时间
      },//查询参数
      dis_input:false,

      activeNames:[],
      labelList:[],
    };
  },
  mounted() {
         this.type=this.$route.query.type
         this.getQueryByTcode();
         this.getProdQuery1st();
         this.getDealerlist();
         this.getCampaignSelete()
         this.getCourseSelete();
         this.getLabelList();
         if(JSON.parse(sessionStorage.getItem('dbUser'))['isRoleDSManager']==true){
         this.pullList[5]['name']=this.$wxuserUtil.getDeptName();
         this.pullList[5]['val']=this.$wxuserUtil.getDeptId();
         }
        if(JSON.parse(sessionStorage.getItem('dbUser'))['isRoleMarketing']==true){
         this.pullList[6]['name']=this.$wxuserUtil.getUserName();
         this.pullList[6]['val']=this.$wxuserUtil.getUserId();
          }

  },
  methods: {
   compareDate(checkStartDate, checkEndDate) {
    var arys1= new Array();
    var arys2= new Array();
    if(checkStartDate != null && checkEndDate != null) {
        arys1=checkStartDate.split('-');
          var sdate=new Date(arys1[0],parseInt(arys1[1]-1),arys1[2]);
        arys2=checkEndDate.split('-');
        var edate=new Date(arys2[0],parseInt(arys2[1]-1),arys2[2]);
    if(sdate > edate) {
        return false;
    }  else {
        return true;
        }
     }
   },

    /**
     * 客户查询确定
     */
    button_confirm(){
     if(this.birthday[0]&&this.birthday[1]){
        if(this.compareDate(this.birthday[0],this.birthday[1])==false){
            this.$title("开始生日日期需小于或等于结束日期");
            return;
        }
     }
     if(this.souvenir[0]&&this.souvenir[1]){
        if(this.compareDate(this.souvenir[0],this.souvenir[1])==false){
            this.$title("开始结婚纪念日日期需小于或等于结束日期");
            return;
        }
     }
     if(this.buyDate[0]&&this.buyDate[1]){
        if(this.compareDate(this.buyDate[0],this.buyDate[1])==false){
            this.$title("开始购买日期需小于或等于结束日期");
            return;
        }
     }
     if(this.predictBuyDate[0]&&this.predictBuyDate[1]){
        if(this.compareDate(this.predictBuyDate[0],this.predictBuyDate[1])==false){
            this.$title("开始预计购买日期需小于或等于结束日期");
            return;
        }
     }

     if(this.activeJoinDate[0]&&this.activeJoinDate[1]){
        if(this.compareDate(this.activeJoinDate[0],this.activeJoinDate[1])==false){
            this.$title("开始参与活动日期需小于或等于结束日期");
            return;
        }
     }
     if(this.courseJoinDate[0]&&this.courseJoinDate[1]){
        if(this.compareDate(this.courseJoinDate[0],this.courseJoinDate[1])==false){
            this.$title("开始参与课程日期需小于或等于结束日期");
            return;
        }
     }
     console.log("this.pullList",this.pullList);

      var params = this.queryParams;
      params.courseStartDate = this.courseJoinDate[0];
      params.courseEndDate = this.courseJoinDate[1];
      params.courseId = this.pullList[14].val;
      params.registerStartDate = this.activeJoinDate[0];
      params.registerEndDate = this.activeJoinDate[1];
      params.campaignId = this.pullList[13].val;
      params.intention = this.pullList[9].val;
      params.purchaseStartDate = this.buyDate[0];
      params.purchaseEndDate = this.buyDate[1];
      params.birthdayStartDate = this.birthday[0];
      params.birthdayEndDate = this.birthday[1];
      params.vipLevel = this.pullList[1].val;
      params.member = this.pullList[2].val;
      params.custType = this.pullList[0].val;
      params.shootingType = this.pullList[3].val;
      params.hobby = this.pullList[4].val;
      params.weddingStartDate = this.souvenir[0];
      params.weddingEndDate = this.souvenir[1];
      params.selectDeptId = this.pullList[5].val;
      params.selectSalesId = this.pullList[6].val;
      params.planBuyStartDate = this.predictBuyDate[0];
      params.planBuyEndDate = this.predictBuyDate[1];
      params.couponNo = this.pullList[11]['name'];
      params.coupon = this.pullList[10].val;
      params.prod2st = this.pullList[8].name;
      params.prod1st = this.pullList[7].name;
      params.purchaseDeptId = this.pullList[12].val;
      params.isAdvanceQuery = true;
      params.regProduct = this.pullList[15].val;
      params.labelList = flattern(this.labelList).join(',')
      var params = {
        q : this.$Base64.encode(JSON.stringify((this.queryParams || {}))),
        type : this.type
      };

      this.$refs.br.blur();
       if(this.type==1){
         this.$router.push({ path: "/Client", query: params });
       }else if(this.type==2){
         this.$router.push({ path: "/Client", query: params });
       }
    },

    /**
     * 客户查询取消
     */
    button_cancel : function () {
         this.clearAll();
    },

    /**
     *   时间选项
     *   @param {val}                     出生日期 1 ~  1.1    结婚纪念日  1.2 ~  1.3    购买日期   1.4  ~  1.5   预计购买日期  1.6  ~  1.7    参与活动日期 1.8 ~  1.9  参与课程日期  2  ~ 2.1
     */
    selectTime(val) {
      console.log("时间点击",val)
      if (val) {
      if(val=="1"||val=="1.1"){
      this.currentDate=new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
      this.maxDate    =new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
      this.minDate    =new Date(this.$D.getFullYear()-70,this.$D.getMonth(),this.$D.getDate());
      }
      if(val=="1.2"||val=="1.3"){
      this.currentDate=new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
      this.maxDate    =new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
      this.minDate    =new Date(this.$D.getFullYear()-70,this.$D.getMonth(),this.$D.getDate());
      }
      if(val=="1.4"||val=="1.5"){
      this.currentDate=new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
      this.maxDate    =new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
      this.minDate    =new Date("2015","1","1");
      }
      if(val=="1.6"||val=="1.7"||val=="1.8"||val=="1.9"||val=="2"||val=="2.1"){
      this.currentDate=new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
      this.maxDate    =new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
      this.minDate    =new Date("2016","1","1");
      }
        this.timeShow = true;
        this.timeVal = val;
      }
    },
    /***
     *  确定 取消 处理事件
     */
    timeConfirm(value) {
      console.log("时间选择",value)
      var date_value =this.$time(value)
      var $index = this.timeVal;
      var [$birthday, $souvenir,$buyDate,$activeJoinDate,$courseJoinDate,$predictBuyDate] = [[], [],[],[],[],[]];

      if ($index == 1) {
        $birthday[0] = date_value;
        $birthday[1] = this.birthday[1];
        this.birthday = $birthday;
      } else if ($index == 1.1) {
        $birthday[1] = date_value;
        $birthday[0] = this.birthday[0];
        this.birthday = $birthday;
      } else if ($index == 1.2) {
        $souvenir[0] = date_value;
        $souvenir[1] = this.souvenir[1];
        this.souvenir = $souvenir;
      } else if ($index == 1.3) {
        $souvenir[1] = date_value;
        $souvenir[0] = this.souvenir[0];
        this.souvenir = $souvenir;
      }else if ($index == 1.4) {
        $buyDate[0] = date_value;
        $buyDate[1] = this.buyDate[1];
        this.buyDate = $buyDate;
      } else if ($index == 1.5) {
        $buyDate[1] = date_value;
        $buyDate[0] = this.buyDate[0];
        this.buyDate = $buyDate;
      }else if ($index == 1.6) {
        $predictBuyDate[0] = date_value;
        $predictBuyDate[1] = this.predictBuyDate[0];
        this.predictBuyDate = $predictBuyDate;
      }else if ($index == 1.7) {
        $predictBuyDate[1] = date_value;
        $predictBuyDate[0] = this.predictBuyDate[0];
        this.predictBuyDate = $predictBuyDate;
      } else if ($index == 1.8) {
        $activeJoinDate[0] = date_value;
        $activeJoinDate[1] = this.activeJoinDate[1];
        this.activeJoinDate = $activeJoinDate;
        this.getCampaignSelete();
      } else if ($index == 1.9) {
        $activeJoinDate[1] = date_value;
        $activeJoinDate[0] = this.activeJoinDate[0];
        this.activeJoinDate = $activeJoinDate;
        this.getCampaignSelete();
      } else if ($index == 2) {
        $courseJoinDate[0] = date_value;
        $courseJoinDate[1] = this.courseJoinDate[1];
        this.courseJoinDate = $courseJoinDate;
        this.getCourseSelete();
      } else if ($index == 2.1) {
        $courseJoinDate[1] = date_value;
        $courseJoinDate[0] = this.courseJoinDate[0];
        this.courseJoinDate = $courseJoinDate;
        this.getCourseSelete();
      }

      this.timeShow = false;
    },
    timeCancel(value) {
      this.timeShow = false;
    },
    timeChange(val, index) {},
    onCancelCode() {
      this.showDownSelection = false;
    },
    onConfirmCode(val) {
      console.log("选择值返回",val)
      console.log("当前索引",this.downSelectionVal)
      switch (this.downSelectionVal) {
          case 0     :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 1     :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 2     :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 3     :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 4     :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 5     :   this.setUpSelectCode(2,this.downSelectionVal,val);break
          case 6     :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 7     :
            this.setUpSelectCode(1,this.downSelectionVal,val);
            this.getProdQuery2st(val.name);
            break;
          case 8     :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 9     :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 10    :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 12    :   this.setUpSelectCode(1,this.downSelectionVal,val);break
          case 13    :   this.setUpSelectCode(13,this.downSelectionVal,val);break
          case 14    :   this.setUpSelectCode(14,this.downSelectionVal,val);break
          case 15    :   this.setUpSelectCode(15,this.downSelectionVal,val);break
      }
      this.showDownSelection=false;

    },
    /**
     *
     *  弹框确定事件  渲染处理
     *  @param {Number}  ID
     *  @param {Number}  index
     *  @param {Object}  value
     *
     */
    setUpSelectCode(ID,index,value){
       if(ID==1){
           this.pullList[index]['name']=value.name||'';
           this.pullList[index]['val']=value.value||'';

           this.showDownSelection = false;
       }
      if(ID==2){
           this.pullList[index]['name']=value.deptName||'';
           this.pullList[index]['val']=value.deptId||'';
           this.showDownSelection = false;
           this.getSaleslist(value.deptId)
      }
      if(ID==3){
           this.cameraList[index]['name']=value.name||'';
           this.cameraList[index]['val']=value.value||'';
           this.showDownSelection = false;
      }
      if(ID == 13){
        this.pullList[index]['name']=value.name||'';
        this.pullList[index]['val']=value.id||'';
        this.showDownSelection = false;
      }
      if(ID == 14){
        this.pullList[index]['name']=value.name||'';
        this.pullList[index]['val']=value.id||'';
        this.showDownSelection = false;
      }
      if(ID == 15){
        this.pullList[index]['name']=value.name||'';
        this.pullList[index]['val']=value.val||'';
        this.showDownSelection = false;
      }

    },
    /**
     *
     * 字典查询
     *
     */
    getQueryByTcode() {
      for (let i = 0; i < this.codeList.length; i++) {
        this.$api.getQueryByTcode({ tcode: this.codeList[i] })
          .then(Response => {
            switch (this.codeList[i]) {
              case "CustomerType"   :  this.CustomerType = Response.data;break;
              case "VIP Level"      :  this.VIPLevel = Response.data;break;
              case "MenbersType"    :  this.MenbersType = Response.data;break;
              case "ShootingType"   :  this.ShootingType = Response.data;break;
              case "Hobby"          :  this.Hobby = Response.data;break;
              case "Intention"      :  this.Intention = Response.data;break;
              case "CouponType"     :  this.CouponType = Response.data;break;
            }
          });
      }
    },
    /**
     *
     *  点击下拉菜单展示
     *
     */
    downSelections(val){
        console.log("点击当前索引",val)
        this.downSelectionVal=val;
        switch(val){
        case 0      :  this.downSelection=this.setCodeAlls(this.CustomerType );  break
        case 1      :  this.downSelection=this.setCodeAlls(this.VIPLevel); break
        case 2      :  this.downSelection=this.setCodeAlls(this.MenbersType); break
        case 3      :  this.downSelection=this.setCodeAlls(this.ShootingType); break
        case 4      :  this.downSelection=this.setCodeAlls(this.Hobby );  break
        case 5      :  this.downSelection=this.setCodeAlls(this.Dealer); break
        case 6      :  this.downSelection=this.setCodeAlls(this.Sales); break
        case 7      :  this.downSelection=this.setCodeAlls(this.Products1stType); break
        case 8      :  this.downSelection=this.setCodeAlls(this.Products2ndType); break
        case 9      :  this.downSelection=this.setCodeAlls(this.Intention); break
        case 10     :  this.downSelection=this.setCodeAlls(this.CouponType); break
        // case 11     :  this.downSelection=this.setCodeAlls(this.Dealer); break
        case 12     :  this.downSelection=this.setCodeAlls(this.Dealer); break
        case 13     :  this.downSelection=this.setCodeAlls(this.campaign); break
        case 14     :  this.downSelection=this.setCodeAlls(this.course); break
        case 15     :  this.downSelection=this.setCodeAlls(this.regProduct); break
    }
    this.showDownSelection=true;
  },
  /**
   *
   *  产品一级分类
   *
   */
  getProdQuery1st(){
      this.$api.getProdQuery1st({salesId: this.$wxuserUtil.getUserId()}).then(Response=>{
       console.log("产品一级分类",Response)
       this.Products1stType=Response.data;
      })
  },
 /**
   *
   *  产品二级分类
   *
   */
  getProdQuery2st(ID){
      this.$api.getProdQuery2st({salesId: this.$wxuserUtil.getUserId(),prod1st:ID}).then(Response=>{
          console.log("二级分类",Response)
          this.Products2ndType=Response.data || [];
      })
  },
   /**
     *
     *  查询经销商
     *
     **/
    getDealerlist() {
      this.$api.getDealerlist({ salesId:this.$wxuserUtil.getUserId(),currentDept:1})
        .then(Response => {
            console.log("门店",Response)
          this.Dealer =this.changeList(Response.data,1);
        });
    },
   /**
     *
     *   销售用户
     *
     **/
    getSaleslist(deptId) {
      this.$api.getSaleslist({salesId: this.$wxuserUtil.getUserId(),deptId:deptId,currentDept:1}).then(Response => {
        console.log("销售顾问",Response)
        this.Sales = this.changeList(Response.data,2);
      });
    },
    /**
     *  参与活动
     */
    getCampaignSelete(){
        this.$api.getCampaignSelete({
          salesId: this.$wxuserUtil.getUserId(),
          startDate : this.activeJoinDate[0],
          endDate : this.activeJoinDate[1]
        }).then(Response=>{
          console.log("参与活动",Response)
          this.campaign=Response.data;
        })
    },
    /**
     * 参与课程
     */
    getCourseSelete(){
        this.$api.getCourseSelete({
          salesId: this.$wxuserUtil.getUserId(),
          startDate : this.courseJoinDate[0],
          endDate : this.courseJoinDate[1],
        }).then(Response=>{
          console.log("参与课程",Response)
          this.course=Response.data;
        })
    },

    changeList(DATA,ID){
        if(Array.isArray(DATA)){
            for(let i=0;i<DATA.length;i++){
                if(ID==1){
                  DATA[i]['name']=DATA[i]['deptName']
                  DATA[i]['value']=DATA[i]['deptId']
                }else{
                  DATA[i]['name']=DATA[i]['userName']
                  DATA[i]['value']=DATA[i]['userId']
                }
            }
            return DATA;
        }
    },
   /**
    *
    *   添加全部
    *
    */
   setCodeAlls(data){

      if(Array.isArray(data)){
        return  [{name:"全部",value:""}].concat(data);
      }else{
        return  [].concat(data);
      }
   },
   /**
    *
    *  清空
    *
    */
        clearAll(){
            for(let i=0;i<this.pullList.length;i++){
                    this.pullList[i]['name']="";
                    this.pullList[i]['val']="";
            }
            for(let o  in  this.queryParams){
                this.queryParams[o]="";
            }
            this.birthday=["", ""]         // 生日选项
            this.souvenir=["", ""]         // 结婚纪念日
            this.buyDate=["", ""]          //  购买日期
            this.predictBuyDate=["", ""]   //预计购买日期
            this.activeJoinDate=["", ""]   //活动参与日期
            this.courseJoinDate=["", ""]   //课程参与日期
            getLabelList()
        },

        getLabelList(){
            this.$api.findLabelList({salesId: this.$wxuserUtil.getUserId()}).then(res=>{
                this.labelList = res.data
            })
        },
        handTreeTab(item,key,index){
            item.active = key
            this.$forceUpdate();
        },
        handTag(info){
            info.use = info.use==1?0:1;
            this.$forceUpdate();
        },
        handNav(item){
            item.active = !item.active
            this.$forceUpdate();
        }
   },
   computed: {
        showTagCnt() {
            //计算二级显示内容
            return function(info){
                let a = info.children.filter((item)=>{
                    return (item.use && item.use==1)
                }).map(v => {return v.labelName})
                return a.length>0? a.join(' ') : '请选择'
            }
        }
    },
    watch: {

    }
};
</script>


<style lang="less" src="~p/pageView-filter.less"></style>
<style lang="less" scoped>
/deep/ .van-tag{
        margin: 5px;
    }
    .taglist{
        padding: 10px;
        border: 1px solid #cacaca;
        border-radius:0.1rem;
        margin: 5px 0;
    }
.tabsub{
        padding: 0rem 0.2rem;
        display: flex;
        .tabNav{
            width: 35%;
            // position: absolute;
            // left: 0;
            // top: 0;
            // bottom: 0;
            min-width: 120px;
            overflow: scroll;
            background-color: #fafafa;
            border: 1px solid #cacaca;
            // border-radius:0.2rem 0 0 0.2rem;
            border-right: 0;
            .navItem{
                position: relative;
                line-height: 44px;
                padding: 0 9px 0 15px;
                color: #000;
                &.navItem--active {
                    font-weight: bold;
                    background-color: #fff;
                }
            }
            .navItem--active::after {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                width: 3.6px;
                background-color: #f44;
                content: '';
            }
        }
        .tabcontent{
            padding: 10px;
            border: 1px solid #cacaca;
            border-left: 0;
            border-radius:0 0.2rem 0.2rem 0;
            flex: 1;
            // margin-left: 10px;
        }
    }
    .collapse-tit{
        display: flex;
        justify-content: center;
        width: 100%;
        .text{

        }
        .tip{
            color: #969799;
            font-size: 12px;
            align-self: center;
            flex: 1;
            text-align: center;
        }
    }
    .pull-down-selects{
        overflow:hidden; white-space:nowrap; text-overflow:ellipsis; padding-right: 20px;
    }
</style>





// WEBPACK FOOTER //
// src/components/client/filter.vue